import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userIdSelector } from '../selectors';
import { IUserInChatListSchema } from '../types/userData';
import { formatCompanionData } from '../utils/formatCompanionData';

export const useChatListItemCompanion = (chatUsers: IUserInChatListSchema[]) => {
  const userId = useSelector(userIdSelector);

  const companion = useMemo(() => {
    const opponent = chatUsers.find(user => user.chatRole === 'opponent');
    const initiator = chatUsers.find(user => user.chatRole === 'initiator');
    const companion = chatUsers.find(user => user.chatRole === 'companion');

    // Если зашли за инициатора - показываем оппонента, если его нет - компаньона
    if (initiator?.userId === userId) {
      return opponent || companion;
    }

    return initiator;
  }, [chatUsers, userId]);

  return useMemo(() => formatCompanionData(companion ?? ({} as IUserInChatListSchema)), [companion]);
};
